import { MovingUnderlineNav } from "@/components/moving-underline-nav";
import { PageContent, PageHeader } from "@/components/page-components";
import { useInvalidateOrganization } from "@/hooks/use-invalidate-organization";
import { AccountView } from "@papier/auth-ui";
import { Button } from "@papier/ui/components/ui/button";
import { createFileRoute, Link, linkOptions } from "@tanstack/react-router";
import { Settings, Shield } from "lucide-react";

export const Route = createFileRoute("/_app/account/$accountView")({
  component: RouteComponent,
  head: () => ({
    meta: [{ title: "Papier - Account" }],
  }),
});

const navigationItems = linkOptions([
  {
    title: "Settings",
    icon: Settings,
    to: "/account/$accountView",
    params: {
      accountView: "settings",
    },
  },
  {
    title: "Security",
    icon: Shield,
    to: "/account/$accountView",
    params: {
      accountView: "security",
    },
  },
  {
    title: "Organizations",
    icon: Settings,
    to: "/account/$accountView",
    params: {
      accountView: "organizations",
    },
  },
]);

function RouteComponent() {
  const { accountView } = Route.useParams();
  const { trpc, queryClient } = Route.useRouteContext();
  const invalidateOrganization = useInvalidateOrganization();

  return (
    <>
      <PageHeader>
        <div className="no-scrollbar overflow-x-auto px-4 pt-1">
          <MovingUnderlineNav>
            {navigationItems.map((item) => {
              return (
                <Button asChild key={item.title} variant="ghost">
                  <Link
                    to={item.to}
                    params={item.params}
                    className="hover:bg-transparent! relative rounded-none px-4 py-2 transition-colors duration-300 ease-in-out"
                    inactiveProps={{
                      className: "text-muted-foreground hover:text-accent",
                    }}
                    activeProps={{
                      className: "text-foreground",
                    }}
                    activeOptions={{ exact: true, includeSearch: false }}
                  >
                    <item.icon className="size-4" />
                    <span>{item.title}</span>
                  </Link>
                </Button>
              );
            })}
          </MovingUnderlineNav>
        </div>
      </PageHeader>
      <PageContent className="mx-auto w-full max-w-7xl">
        <AccountView
          path={accountView}
          onInvalidateInvitations={async () => {
            queryClient.invalidateQueries(trpc.authTrpc.getUserInvitations.queryFilter());
            queryClient.invalidateQueries(trpc.authTrpc.getUserOrganizations.queryFilter());
          }}
          onLeaveOrganizationSuccess={invalidateOrganization}
        />
      </PageContent>
    </>
  );
}
